import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {sharedStyles} from 'antibodies/format/help-modal/shared';
import {FONT_WEIGHT_PROXIMA_SEMIBOLD} from 'styles/FontConstants';

export function BasicsTab(): JSX.Element {
  return (
    <div>
      <section className={css(sharedStyles.section)}>
        <h4>Key concepts</h4>
        <p>The VERITAS scheme breaks down all antibody formats into modular components:</p>
        <ul className={css(styles.list)}>
          <li>
            <strong>N-terminal appendages:</strong> Modules attached to the N-terminus of the center
          </li>
          <li>
            <strong>Multimerization center:</strong> The core multimeric structure
          </li>
          <li>
            <strong>C-terminal appendages:</strong> Modules attached to the C-terminus of the center
          </li>
        </ul>
      </section>

      <section className={css(sharedStyles.section)}>
        <h4>Syntax rules</h4>
        <div className={css(styles.syntaxRule)}>
          <span className={css(styles.syntaxSymbol)}>Dash -</span>
          <span>Connects modules on the same amino acid chain</span>
        </div>
        <div className={css(styles.syntaxRule)}>
          <span className={css(styles.syntaxSymbol)}>Asterisk *</span>
          <span>Separates modules on different amino acid chains</span>
        </div>
        <div className={css(styles.syntaxRule)}>
          <span className={css(styles.syntaxSymbol)}>Square brackets [ ]</span>
          <span>Denotes asymmetric appendages</span>
        </div>
        <div className={css(styles.syntaxRule)}>
          <span className={css(styles.syntaxSymbol)}>Colon :</span>
          <span>Indicates a non-covalent interaction between modules</span>
        </div>
        <div className={css(styles.syntaxRule)}>
          <span className={css(styles.syntaxSymbol)}>Parentheses ( )</span>
          <span>Labels a target specificity for the following module</span>
        </div>
        <div className={css(styles.syntaxRule)}>
          <span className={css(styles.syntaxSymbol)}>Exclamation point !</span>
          <span>Reverses the domains of the preceding module</span>
        </div>
      </section>

      <section className={css(sharedStyles.section)}>
        <h4>Symmetric vs. Asymmetric</h4>
        <p>
          <strong>Symmetric:</strong> Both chains have the same appendages
        </p>
        <p>
          <strong>Asymmetric:</strong> Chains have different appendages (use brackets)
        </p>
      </section>
    </div>
  );
}

const styles = StyleSheet.create({
  list: {
    paddingLeft: '20px',
  },
  syntaxRule: {
    display: 'flex',
  },
  syntaxSymbol: {
    fontWeight: FONT_WEIGHT_PROXIMA_SEMIBOLD,
    minWidth: '120px',
  },
});
